import localFont from "next/font/local";

/**
 * Self-hosted fonts bundled & optimized by Next.js (next/font/local).
 * Drop the font file in this folder and register it below.
 */
export const avenirNextBold = localFont({
  src: "./AvenirNext-Bold.ttf",
  weight: "700",
  style: "normal",
  display: "swap",
});

/**
 * Registry mapping a config-friendly key to the generated CSS font-family
 * value. Team configs reference a key (string) and the UI resolves it to the
 * actual (hashed) family name produced by next/font.
 */
export const customFonts = {
  avenirNextBold: avenirNextBold.style.fontFamily,
} as const;

export type CustomFontKey = keyof typeof customFonts;
